import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 20h-11a3 3 0 0 1 0 -6h11a3 3 0 0 0 0 6h1a3 3 0 0 0 3 -3v-11a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8","key":"svg-0"}]]

/**
 * IconScript
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2NyaXB0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNyAyMGgtMTFhMyAzIDAgMCAxIDAgLTZoMTFhMyAzIDAgMCAwIDAgNmgxYTMgMyAwIDAgMCAzIC0zdi0xMWEyIDIgMCAwIDAgLTIgLTJoLTEwYTIgMiAwIDAgMCAtMiAydjgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/script
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconScript = createReactComponent('outline', 'script', 'Script', __iconNode);

export default IconScript;